import React, {Fragment} from 'react';
import './Header.css';
import {Link} from 'react-router-dom';

const Header = () =>{
    return(
        <Fragment>
            <div className="content-header">
                <Link to="/" >El Pollo Rico</Link>
            </div>
        </Fragment>
    );  
}

export default Header;